import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import chatList, { getChatListSaga } from 'modules/actions/chat';
import fontSize from 'modules/actions/fontSize';
import { sendSatisfyactionSaga } from 'modules/actions/starScore';
import usability, { sendUsaAbilityactionSaga } from 'modules/actions/starUsability';
import organizationResult, { sendOrganizationSaga } from 'modules/actions/sendOrganization';
import complaintResult, { sendComplaintSaga } from 'modules/actions/sendComplaint';
import complaintSearchResult, { sendComplaintSearchSaga } from 'modules/actions/sendComplaintSearch';
import complaintTypeResult, { getComplaintTypeInfoSaga } from 'modules/actions/getComplaintTypeInfo';
import { insertUrlEvtSaga } from 'modules/actions/insertUrlEvent';
import autoComplete, { autoCompleteSaga } from 'modules/actions/autoComplete/index';
import isActive from 'modules/actions/statusMenu/index';
import quality, { getQualityOptions, sendQualityGenerator } from 'modules/actions/quality';

const rootReducer = combineReducers({
  autoComplete,
  isActive,
  chatList,
  fontSize,
  quality,
  organizationResult,
  complaintResult,
  complaintSearchResult,
  complaintTypeResult,
  usability,
});

export function* rootSaga() {
  yield all([
    autoCompleteSaga(),
    getChatListSaga(),
    sendSatisfyactionSaga(),
    getQualityOptions(),
    sendUsaAbilityactionSaga(),
    sendQualityGenerator(),
    sendOrganizationSaga(),
    sendComplaintSaga(),
    sendComplaintSearchSaga(),
    getComplaintTypeInfoSaga(),
    insertUrlEvtSaga(),
  ]);
}

export default rootReducer;
